// @ts-nocheck
// get all approved events
export const FETCH_APPROVED_EVENTS_REQUEST = "FETCH_APPROVED_EVENTS_REQUEST";
export const FETCH_APPROVED_EVENTS_SUCCESS = "FETCH_APPROVED_EVENTS_SUCCESS";
export const FETCH_APPROVED_EVENTS_FAILURE = "FETCH_APPROVED_EVENTS_FAILURE";

// clear all approved  data
export const CLEAR_APPROVED_EVENTS = "CLEAR_APPROVED_EVENTS";